import { getAwsEsClient } from '@/services/aws_es_client'
import AWS from 'aws-sdk'
// import connectionClass from 'http-aws-es'
// import elasticsearch from 'elasticsearch'
import $store from '@/store/store.js'

const setCognitoConf = () => {
	AWS.config.region = window.appConfig._$q77vss
	let user = $store.getters.user
	let logins = {}
	logins[new URL(window.appConfig._$jpa1qd).hostname] = user.google_id_token
	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: window.appConfig._$bocc7y,
		Logins: logins
	})
}

const refreshCognitoWithOidcIdToken = (tp_user) => {
	return new Promise((resolve, reject) => {
		// Vérification que l'utilisateur et son token existent
		if (!tp_user || !tp_user.id_token) {
			reject(new Error('User or id_token is missing. Please authenticate again.'))
			return
		}

		let gravity_user = $store.getters.user
		gravity_user.google_id_token = tp_user.id_token
		$store.commit('set_user', gravity_user)

		// Initialize Cognito credentials if not yet created
		// (can happen if addUserLoaded fires before the first ES query)
		if (!AWS.config.credentials) setCognitoConf()

		AWS.config.credentials.params.Logins[new URL(window.appConfig._$jpa1qd).hostname] = tp_user.id_token
		refreshCognitoCreds()
			.then(() => {
				let client = getAwsEsClient()
				resolve(client)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

const refreshCognitoCreds = () => {
	return new Promise((resolve, reject) => {
		AWS.config.credentials.refresh(error => {
			if (error) {
				reject(error)
			} else {
				resolve()
			}
		})
	})
}

const getClient = () => {
	return new Promise((resolve, reject) => {
		if (!AWS.config.credentials) setCognitoConf()
		if (!AWS.config.credentials.needsRefresh()) {
			let client = getAwsEsClient()
			resolve(client)
		} else {
			// Try to refresh credentials proactively, but don't block
			// the request if it fails — http-aws-es will attempt its own
			// refresh via AWS.config.getCredentials() on each request,
			// using the Logins map (kept up-to-date by addUserLoaded).
			$store.dispatch('auth/getUser')
				.then(user => {
					if (!user) {
						console.warn('ES: No valid OIDC user, delegating credential refresh to http-aws-es')
						return getAwsEsClient()
					}
					return refreshCognitoWithOidcIdToken(user)
				})
				.then(client => {
					resolve(client)
				})
				.catch(error => {
					console.warn('ES: Proactive credential refresh failed, delegating to http-aws-es', error)
					resolve(getAwsEsClient())
				})
		}
	})
}

const getData = (query, index) => {
	return new Promise((resolve, reject) => {
		getClient()
			.then(elasticClient => {
				return elasticClient.search({
					index: index,
					body: JSON.stringify(query)
				})
			})
			.then(response => {
				$store.commit('set_maestro_es_status', true)
				resolve(response)
			})
			.catch(error => {
				$store.commit('set_maestro_es_status', false)
				reject(error)
			})
	})
}

export default {
	getClient,
	getData,
	refreshCognitoWithOidcIdToken
}



// WEBPACK FOOTER //
// ./src/api/elasticSearchClient.js